import React from "react";
import { Phone, Instagram, Facebook, CreditCard } from "lucide-react";
import { Link } from "react-router-dom";
import { useSection } from "@/context/SiteContext";
import { telHref, resolveImageUrl } from "@/lib/site";

export default function Footer() {
  const brand = useSection("brand");
  const nav = useSection("nav");
  const contact = useSection("contact");
  const footer = useSection("footer");
  const tel = telHref(contact.phone_tel, contact.phone);
  const logoSrc = resolveImageUrl(brand.logo_url);
  const brandName = brand.name || "Mon Ami";

  return (
    <footer className="bg-[var(--surface-alt)] border-t border-[var(--border)] pb-24 md:pb-12 pt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-3">
              {logoSrc ? (
                <img src={logoSrc} alt={brandName} className="h-12 w-12 rounded-full object-cover ring-1 ring-[var(--border)]" />
              ) : (
                <span className="inline-block w-8 h-8 rounded-full bg-[var(--primary)] text-white grid place-items-center font-bold font-serif-display text-lg">
                  {(brand.initial || "M").slice(0, 1)}
                </span>
              )}
              <span className="font-serif-display text-xl font-bold">{brandName}</span>
            </div>
            <p className="text-sm text-[var(--text-muted)] leading-relaxed">{footer.tagline}</p>
            <div className="flex gap-2 mt-4">
              {footer.instagram_url && (
                <a href={footer.instagram_url} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-white border border-[var(--border)] grid place-items-center hover:text-[var(--primary)]">
                  <Instagram size={15} />
                </a>
              )}
              {footer.facebook_url && (
                <a href={footer.facebook_url} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-white border border-[var(--border)] grid place-items-center hover:text-[var(--primary)]">
                  <Facebook size={15} />
                </a>
              )}
            </div>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-widest font-semibold text-[var(--text-muted)] mb-4">Snabblänkar</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#meny" className="hover:text-[var(--primary)]">{nav.menu_label || "Meny"}</a></li>
              <li><a href="#kontakt" className="hover:text-[var(--primary)]">{nav.contact_label || "Kontakt"}</a></li>
              <li><a href={tel} className="hover:text-[var(--primary)]">Beställ</a></li>
              <li><Link to="/login" data-testid="footer-admin-link" className="hover:text-[var(--primary)]">Admin</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-widest font-semibold text-[var(--text-muted)] mb-4">Betalning</h4>
            <div className="flex items-center gap-2 text-sm">
              <CreditCard size={16} className="text-[var(--primary)]" />
              {footer.payment_label || "Kort & kontant"}
            </div>
            <a href={tel} className="mt-4 inline-flex items-center gap-2 text-sm font-semibold hover:text-[var(--primary)]">
              <Phone size={14} /> {contact.phone}
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-[var(--border)] flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[var(--text-muted)]">
          <span>© {new Date().getFullYear()} Restaurang {brand.name || "Mon Ami"}. Alla rättigheter förbehållna.</span>
          <span>{contact.address} · Öppet {contact.hours_time}</span>
        </div>
      </div>
    </footer>
  );
}
